/**
 * Device detection utilities for cross-device compatibility
 */

/**
 * Helper to detect if it's a desktop browser (to avoid false positives)
 */
function isDesktopBrowser(): boolean {
  if (typeof window === 'undefined') return false;
  const userAgent = navigator.userAgent || '';
  // Desktop browsers that might have touch support
  const desktopRegex = /windows|macintosh|linux/i;
  // If it's a desktop OS but window is small, it's likely a resized window, not mobile
  return desktopRegex.test(userAgent) && window.innerWidth > 600;
}

/**
 * Utility function to detect mobile devices - improved for cross-device compatibility
 * @returns true if the device is detected as mobile
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;
  
  // Check for mobile user agents (more comprehensive list)
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || '';
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet|kindle|silk|fennec/i;
  
  // Check if it's a mobile user agent
  const isMobileUA = mobileRegex.test(userAgent);
  
  // Check screen width (mobile devices typically have smaller screens)
  // Use a more conservative threshold to avoid false positives on tablets
  const isSmallScreen = window.innerWidth <= 768;
  
  // Check for touch support (mobile devices typically have touch)
  const hasTouch = 'ontouchstart' in window || Boolean(navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
  
  // Check if it's iOS (always use redirect for iOS)
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  
  // Consider it mobile if:
  // 1. It's iOS (always use redirect)
  // 2. It matches mobile user agent
  // 3. It's a small screen with touch support (but not desktop browser in small window)
  return Boolean(isIOS || isMobileUA || (isSmallScreen && hasTouch && !isDesktopBrowser()));
}
